/** Предпочтительный MIME для голосовых: Opus в WebM (браузерный MediaRecorder). */
export const WEBM_OPUS_MIME = 'audio/webm;codecs=opus';

export function getSupportedWebmOpusMimeType(): string | null {
  if (typeof MediaRecorder === 'undefined' || !MediaRecorder.isTypeSupported) {
    return null;
  }

  if (MediaRecorder.isTypeSupported(WEBM_OPUS_MIME)) {
    return WEBM_OPUS_MIME;
  }

  return null;
}

export function formatMmSs(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) {
    return '00:00';
  }
  const totalSec = Math.floor(ms / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}
